"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var player_1 = require("../../stores/player");
var _kernel_store_types_1 = require("../../types");
var global_1 = require("../../stores/global");
var checkRequiredPlayState_1 = __importDefault(require("./checkRequiredPlayState"));
var player_2 = require("../../selectors/player");
function checkAutoPlay() {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/checkAutoPlay");
        var settings = _kernel_container_1.default.get("SETTINGS");
        var _a = selector(getState()), autoPlay = _a.autoPlay, autoPlayTriggered = _a.autoPlayTriggered, pointId = _a.pointId, lastRequiredPlayState = _a.lastRequiredPlayState;
        var autoPlayEnabled = settings.getSetting("AUTOPLAY_ENABLED", false);
        var forceAutoplay = settings.getSetting("FORCE_AUTOPLAY", false);
        var setLastPlayState = settings.getSetting("SET_LAST_PLAY_STATE", true);
        if (!autoPlayEnabled && !setLastPlayState) {
            logger.debug("Autoplay disabled, skipping...");
            return;
        }
        if (!pointId) {
            logger.debug("Got no point, skipping autoplay check...");
            return;
        }
        if (autoPlayTriggered) {
            logger.debug("Autoplay already triggered, skipping...");
            return;
        }
        if (autoPlay || forceAutoplay) {
            dispatch((0, player_1.setRequiredPlayState)(_kernel_store_types_1.EPlayState.PLAY));
        }
        if (setLastPlayState && lastRequiredPlayState === _kernel_store_types_1.EPlayState.PLAY) {
            dispatch((0, player_1.setRequiredPlayState)(_kernel_store_types_1.EPlayState.PLAY));
        }
        dispatch((0, global_1.setAutoPlayTriggered)());
        dispatch((0, checkRequiredPlayState_1.default)());
    };
    action.type = checkAutoPlay.type;
    return action;
}
checkAutoPlay.type = "checkAutoPlay";
exports.default = checkAutoPlay;
function selector(state) {
    return {
        autoPlay: state.global.autoPlay,
        autoPlayTriggered: state.global.autoPlayTriggered,
        pointId: state.point.id,
        lastRequiredPlayState: (0, player_2.selectLastRequiredPlayState)(state),
    };
}
//# sourceMappingURL=checkAutoPlay.js.map